import { render, staticRenderFns } from "./TeacherStudio.vue?vue&type=template&id=1f037c14&scoped=true"
import script from "./TeacherStudio.vue?vue&type=script&lang=js"
export * from "./TeacherStudio.vue?vue&type=script&lang=js"
import style0 from "./TeacherStudio.vue?vue&type=style&index=0&id=1f037c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f037c14",
  null
  
)

export default component.exports